import { css, cx } from "@linaria/core"
import { styled } from "@linaria/react"
import { useContext } from "react"

import { AgentIterationStyles } from "@/components/AgentIteration/AgentIterationStyles.ts"
import { EllipsisContainer } from "@/components/Ellipsis/Ellipsis.ts"
import { Horizontal } from "@/components/Flex.ts"
import { MarkdownWrapper } from "@/components/Markdown/MarkdownWrapper.tsx"
import { Rotate } from "@/components/Spinner/Spinner.tsx"
import { CheckmarkRegular, ClockRegular, SpinnerRegular } from "@/icons/Icons.ts"
import { TaskViewModelContext } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"
import * as textStyles from "@/styles/textStyles.ts"

import type { UIToolCallObservation } from "@/lib/client/generated/TypeDefinitions.ts"

export const ReasoningResult_TodoList = (props: {
  content: UIToolCallObservation.TodoList
}) => {
  const model = useContext(TaskViewModelContext)
  const isRunning = model?.agentIsRunning.get() === true
  return (
    <Container>
      <EllipsisContainer>
        <MarkdownWrapper
          text={props.content.message}
          inlineOnly
          className={AgentIterationStyles.secondLevelMarkdown}
        />
      </EllipsisContainer>
      <List>
        {props.content.items.map((item, idx) => (
          <ListItem key={`${item.title}-${idx}`}>
            {(item.state === "Done") && <CheckIcon />}
            {(item.state === "InProgress") && (
              <SpinnerRegular className={cx(SpinnerIcon, isRunning ? Rotate : undefined)} />
            )}
            {(item.state === "Pending") && <ClockIcon />}
            <ItemTitle
              className={item.state === "InProgress" && isRunning ? AgentIterationStyles.secondLevelText_Loading : undefined}
            >
              {item.title.value}
            </ItemTitle>
          </ListItem>
        ))}
      </List>
    </Container>
  )
}

const Container = styled.div`
  ${AgentIterationStyles.secondLevelText};
  color: var(--secondary-text-color);
  border: 1px solid var(--separator-color);
  border-radius: var(--border-radius-8);
  padding: 8px;
  margin-bottom: 8px;
`

const List = styled.ul`
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const ListItem = styled(Horizontal)`
  display: flex;
  align-items: center;
  gap: 6px;
  ${textStyles.smallestFontSize};
  ${textStyles.breakWord};
`

const ItemTitle = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const CheckIcon = styled(CheckmarkRegular)`
  width: 12px;
  height: 12px;
  color: var(--secondary-text-color);
`

const SpinnerIcon = css`
  width: 12px;
  height: 12px;
  color: var(--secondary-text-color);
`

const ClockIcon = styled(ClockRegular)`
  width: 12px;
  height: 12px;
  color: var(--secondary-text-color);
`
